import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ConfigService} from "common";
import { LoginErrorModalComponent } from "common/components/login-error-modal/login-error-modal.component";


// @dynamic
@Injectable()
export class PipeLineErrorService {

    public isPipelineError = false;

  constructor(private configService: ConfigService,
    private httpsClient: HttpClient,
    private matDialog: MatDialog,
    private dialogRef: MatDialogRef<LoginErrorModalComponent>
  ) { }

  displayCorsError(error) {
     let modalData = {
      header: "Error Message",
      errorMessage: "",
      aulProfile: {} as any,
      pipeLineError : error
    };
    this.isPipelineError = true;
    window['config'].siteSettings =null;
    this.dialogRef = this.matDialog.open(LoginErrorModalComponent, {
      height: 'auto',
      data: modalData,

    });
    this.dialogRef.afterClosed().subscribe((result) => {
      if (result && result.toLowerCase() === "close") {
        this.isPipelineError = false;
      }
    });
  }
  getUserProfileFromAUL() {
    const headerDict = {
      'ngsw-bypass': 'true',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT',
      'If-Modified-Since': '0',
      "ClientId": this.configService.clientId
    }
    return  this.httpsClient.get<any>(
        `${this.configService.aulApiUrl}api/v${
        this.configService.apiVersion
        }/Error/corscheck`,
        {
          headers: headerDict
        }
       
      )
  }

}
